import { render, staticRenderFns } from "./resubmit.vue?vue&type=template&id=7e109ce4"
import script from "./resubmit.vue?vue&type=script&lang=js"
export * from "./resubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports